import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../PageHeader';
import CorporateSectionLayout from '../../CorporateSectionLayout';
import VisiMisi from './VisiMisi';
import ProfilPerusahaan from './ProfilPerusahaan';
import SejarahPerusahaan from './SejarahPerusahaan';

function TentangPerusahaanLayout() {
    const items = [
        { id: 'profil-perusahaan', number: '01', label: 'Profil Perusahaan', content: <ProfilPerusahaan />, surface: false },
        { id: 'visi-misi', number: '02', label: 'Visi & Misi', content: <VisiMisi />, surface: false },
        { id: 'sejarah-perusahaan', number: '03', label: 'Sejarah Perusahaan', content: <SejarahPerusahaan />, surface: false },
    ];

    return (
        <>
            <Helmet>
                <title>Tentang Perusahaan | PT Len Telekomunikasi Indonesia</title>
                <meta name="description" content="Profil perusahaan, visi & misi, dan sejarah PT Len Telekomunikasi Indonesia." />
                <link rel="canonical" href="https://www.len-telko.co.id/tentang-perusahaan" />
                <meta property="og:title" content="Tentang Perusahaan | PT Len Telekomunikasi Indonesia" />
                <meta property="og:description" content="Pelajari profil, visi misi, dan sejarah PT LTI." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.len-telko.co.id/tentang-perusahaan" />
                <meta property="og:image" content="https://www.len-telko.co.id/logo512.png" />
            </Helmet>
            <PageHeader title="Tentang Perusahaan" />
            <CorporateSectionLayout title="Tentang Perusahaan" items={items} />
        </>
    );
}

export default TentangPerusahaanLayout;
